var $ = require( "jquery" );

// require("./Parallax.js");
require("./gsap.min.js");
require("./ScrollTrigger.min.js");
require("./scrolling.js")($);
require("./swiper.js");
require("./LabelFilter.js");
require("./Menu.js");
require("./forms.js")($);
require("./Dropdown.js")($);
require("./InfiniteScroll.js")($);
require('./animations.js')($, gsap, ScrollTrigger);

/**
 * back to top
 */
$(window).ready(function () {
    $('.back-to-top').on('click', function(){
        $("html, body").animate({ scrollTop: 0}, 800 );
    })
})
